import { walletInternalStructureMap } from 'maps/walletMaps/walletMaps';

/**
 * Parses a wallet payment method into its internal structure.
 *
 * @param paymentMethod - The wallet payment method object to be parsed.
 * @returns The internal wallet structure if the wallet type is supported, otherwise `null`.
 */
export const parseWalletToInternalStructure = paymentMethod => {
  const walletInternal = walletInternalStructureMap[paymentMethod?.walletType];
  return walletInternal ? walletInternal(paymentMethod) : null;
};
